import {createContext, type ReactNode, useCallback, useContext, useState} from "react";

const FontSizeContext = createContext<
  {fontSize: number; reduceFontSize: () => void; increaseFontSize: () => void} | undefined
>(undefined);

export const stepSize = 1;
export const initialFontSize = 16;
export const maxStep = 3;

export const FontSizeProvider = ({children}: {children: ReactNode}) => {
  const [fontSize, setFontSize] = useState(initialFontSize);

  const increaseFontSize = useCallback(() => {
    if (fontSize === initialFontSize + maxStep * stepSize) {
      return;
    }
    setFontSize((prev) => prev + stepSize);
  }, [fontSize]);

  const reduceFontSize = useCallback(() => {
    if (fontSize === initialFontSize) {
      return;
    }
    setFontSize((prev) => prev - stepSize);
  }, [fontSize]);
  return (
    <FontSizeContext.Provider value={{fontSize, reduceFontSize, increaseFontSize}}>
      {children}
    </FontSizeContext.Provider>
  );
};

export const useFontSize = () => {
  return useContext(FontSizeContext);
};
